import { getToken, setStore, getStore } from "@/utils/auth";
import { checkPermission, PermissionType } from "@/utils/permission";
let MIXIN = {
  components: {},
  data() {
    return {
      routerName: "",
      imgApi: process.env.VUE_APP_BASE_API,
    };
  },
  watch: {
    $route(newValue) {
      if (newValue) {
        console.log(newValue);
        this.routerName = newValue.name;
      }
    },
  },
  created() {
    if (this.$route) {
      this.routerName = this.$route.name;
    }
  },
  mounted() { },
  methods: {
    isSameUser(userId) {
      return userId === JSON.parse(getStore("userInfo")).id;
    },
    isAuthSeller() {
      return checkPermission(PermissionType.AUTH_SELLER);
    },
    isAuthBuyer() {
      return checkPermission(PermissionType.AUTH_BUYER);
    },
    isAuthLogistics() {
      return checkPermission(PermissionType.AUTH_LOGISTICS);
    },
    isAuth() {
      return checkPermission(PermissionType.AUTH_REAL);
    },
    refreshPermissions() {
      this.getUserInfoMixin();
    },
    changeAuthVisible(value) {
      this.$store.commit("changeCertVisibleState", value);
    },
    adClick(item) {
      switch (item.detailType) {
        case 1:
          // 富文本
          this.linkJump("/RichText", { id: item.id });
          break;
        case 2:
          // 链接
          this.openWindow(item.linkUrl);
          break;
        default:
          break;
      }
    },
    downloadFile(url, fileName) {
      // 使用fetch API下载文件，支持PDF等文件类型
      fetch(url, { mode: "cors" })
        .then((response) => {
          console.log("url is ok");

          if (!response.ok) {
            throw new Error("网络请求失败");
          }
          return response.blob();
        })
        .then((blob) => {
          // 创建下载链接
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = fileName || "download";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(downloadUrl);

          this.$message({
            message: "下载成功",
            type: "success",
          });
        })
        .catch((error) => {
          console.error("下载失败:", error);
          // this.$message({
          //   message: "下载失败，请在新窗口打开下载",
          //   type: "error",
          // });
          setTimeout(() => {
            this.openWindow(url);
          }, 1000);
        });
    },

    linkJump(link, params = {}, after) {
      console.log(link);
      let routeData = this.$router.resolve({
        path: link,
        query: params,
      });
      console.log("看看routeData", routeData);
      if (!getToken()) {
        if (link === "/login") {
          if (after) {
            setStore("urlRecord", after);
          } else {
            setStore("urlRecord", this.$route.fullPath);
          }
        } else {
          setStore("urlRecord", routeData.route.fullPath);
        }
      }
      // if (!this.$common.isEmpty(params.id)) {
      //   window.open(routeData.href + "?id=" + params.id);
      // } else {
      window.open(routeData.href);
      // }
    },
    // // 判断是否是认证卖家
    // isAuthSeller() {
    //   console.log("isAuthSeller");

    //   // await this.getAuthInfoMixin();
    //   return getStore("isAuthSeller") == "1";
    // },
    // // 判断是否是认证买家
    // isAuthBuyer() {
    //   console.log("isAuthBuyer");
    //   // await this.getAuthInfoMixin();
    //   return getStore("isAuthBuyer") == "1";
    // },
    // // 判断是否是认证物流商家
    // isAuthLogistics() {
    //   console.log("isAuthLogistics");
    //   // await this.getAuthInfoMixin();
    //   // console.log("认证物流商", getStore("isAuthLogistics") == "1");

    //   return getStore("isAuthLogistics") == "1";
    // },
    // // 判断是否实名认证
    // async isAuth() {
    //   console.log("isAuth");
    //   await this.getUserInfoMixin();
    //   return getStore("isAuth") == "1";
    // },

    // 身份证脱敏
    maskCode(code) {
      if (!code || code.length < 10) return code;
      return (
        code.substring(0, 6) + "**********" + code.substring(code.length - 4)
      );
    },

    // 统一社会信用代码脱敏
    enterpriseCode(code) {
      if (!code || code.length < 10) return code;
      return code.substring(0, 8) + "*******" + code.substring(code.length - 3);
    },

    // 查看上传图片打开新窗口
    openImg(url) {
      window.open(url, "_blank");
    },
    openWindow(url) {
      window.open(url, "_blank");
    },
  },
};
export default MIXIN;
